import { render } from "./userSettings.vue?vue&type=template&id=15bf8fee&scoped=true"
import script from "./userSettings.vue?vue&type=script&lang=js"
export * from "./userSettings.vue?vue&type=script&lang=js"

import "./userSettings.vue?vue&type=style&index=0&id=15bf8fee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bf8fee"]])

export default __exports__